import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  const handleEmergencyCall = () => {
    window.location.href = 'tel:0827935785';
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:info@meriodine.co.za';
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-primary via-secondary to-primary text-primary-foreground relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-64 h-64 md:w-96 md:h-96 border-4 border-accent rounded-full"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 md:w-72 md:h-72 border-4 border-accent rounded-full"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-headline font-bold text-2xl md:text-3xl lg:text-4xl mb-4">
            Need Electrical Services?
          </h2>
          <p className="font-body text-base md:text-lg opacity-90 max-w-3xl mx-auto">
            Whether it's an emergency or scheduled service, Gert is ready to help. With 30+ years of experience and 24/7 availability, you're in expert hands.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-8 md:mb-12">
          <div className="bg-card/10 backdrop-blur-sm border border-primary-foreground/20 rounded-xl p-6 md:p-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-error">
                <Icon name="AlertTriangle" size={24} color="white" />
              </div>
              <h3 className="font-headline font-semibold text-xl">Emergency Service</h3>
            </div>
            <p className="font-body text-sm opacity-80 mb-6">
              Electrical emergencies require immediate attention. Call now for rapid response and expert diagnosis.
            </p>
            <Button
              variant="default"
              size="lg"
              onClick={handleEmergencyCall}
              iconName="Phone"
              iconPosition="left"
              className="w-full bg-error hover:bg-error/90 text-error-foreground emergency-cta"
            >
              Emergency: 082 793 5785
            </Button>
          </div>

          <div className="bg-card/10 backdrop-blur-sm border border-primary-foreground/20 rounded-xl p-6 md:p-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-accent">
                <Icon name="Calendar" size={24} color="white" />
              </div>
              <h3 className="font-headline font-semibold text-xl">Schedule Service</h3>
            </div>
            <p className="font-body text-sm opacity-80 mb-6">
              Book a convenient time for inspections, installations, or non-urgent electrical work.
            </p>
            <Button
              variant="outline"
              size="lg"
              onClick={handleEmailClick}
              iconName="Mail"
              iconPosition="left"
              className="w-full bg-primary-foreground text-primary hover:bg-primary-foreground/90"
            >
              Request Appointment
            </Button>
          </div>
        </div>

        <div className="bg-card/10 backdrop-blur-sm border border-primary-foreground/20 rounded-xl p-6 md:p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="text-center">
              <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-accent">
                <Icon name="Award" size={32} color="white" />
              </div>
              <h4 className="font-headline font-semibold text-lg mb-2">30+ Years Experience</h4>
              <p className="font-body text-sm opacity-80">
                Three decades of proven electrical expertise across residential and commercial projects
              </p>
            </div>

            <div className="text-center">
              <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-accent">
                <Icon name="Shield" size={32} color="white" />
              </div>
              <h4 className="font-headline font-semibold text-lg mb-2">Fully Certified</h4>
              <p className="font-body text-sm opacity-80">
                All work certified and compliant with South African electrical safety standards
              </p>
            </div>

            <div className="text-center">
              <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-accent">
                <Icon name="Clock" size={32} color="white" />
              </div>
              <h4 className="font-headline font-semibold text-lg mb-2">24/7 Availability</h4>
              <p className="font-body text-sm opacity-80">
                Round-the-clock emergency service with rapid response across all service areas
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 md:mt-12 text-center">
          <p className="font-body text-sm opacity-80 mb-4">
            Trusted by major brands including McDonald's and KFC for commercial electrical services
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            {[
              "Emergency Response",
              "Fault Finding",
              "Installations",
              "Safety Inspections",
              "Commercial Projects",
              "Residential Service"
            ]?.map((service, index) => (
              <span
                key={index}
                className="inline-flex items-center gap-2 px-4 py-2 bg-card/20 backdrop-blur-sm rounded-full font-accent text-sm"
              >
                <Icon name="Check" size={14} />
                {service}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;